import { Typography, Button } from 'antd';
import { DollarOutlined, KeyOutlined, SearchOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { Logo } from '../../Common/Icon';
import Simple from '../Simple';
import styles from './index.module.less';
import SuccessStoryCarousel from './SuccessStories/SuccessStoryCarousel';
import { useAuth } from '../../../context/auth';

interface Simple {
  children: React.ReactNode;
}

const Auth = ({ children }: Simple): JSX.Element => {
  const { pathname } = useLocation()

  const isSetupPage = pathname.includes('/setup');

  const { user } = useAuth();
  const paymentSetupRequired = Boolean(user?.paymentSetupRequired);

  return (
    <Simple>
      <div className={styles.wrapper}>
        <div className={clsx([styles.container, 'page-container'])}>
          <div className={styles.content}>
            <div className={styles.logosContainer}>
              <Logo
                className={clsx(styles.logo, {
                  [styles.logoOnOtherPages]: !isSetupPage || !paymentSetupRequired,
                })}
              />
              {isSetupPage && paymentSetupRequired && (
                <div className={styles.guaranteeContainer}>
                  <img src="/30-days-money-back-guarantee.png" alt="30 days money back guarantee" />
                </div>
              )}
            </div>
            {children}
          </div>
          <div className={styles.info}>
            <Typography.Title className={styles.title}>
              Mortgage Maker Loan Originator Success Stories
            </Typography.Title>

            <SuccessStoryCarousel />
            <div className={styles.authButtons}>
              <Button
                type="primary"
                href="https://mortgagemaker.ai/mortgage-maker-mortgage-presentation-software-features"
                target="_blank"
                className={styles.authButton}
                size="large"
              >
                Explore the Mortgage Maker Platform Features
                <SearchOutlined className={styles.icon} />
              </Button>
              <Button
                type="primary"
                href="https://mortgagemaker.ai/pricing/"
                target="_blank"
                className={styles.authButton}
                size="large"
              >
                Additional Pricing Info (30-Day Money Back Guarantee)
                <DollarOutlined className={styles.icon} />
              </Button>
              <Button
                type="primary"
                href="https://mortgagemaker.ai/mortgage-loan-officer-resources/"
                target="_blank"
                className={styles.authButton}
                size="large"
              >
                Access Mortgage Maker’s Resource Center
                <KeyOutlined className={styles.icon} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Simple>
  )
};

export default Auth;
